var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEarlymorning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "early_morning",
    "data-name": "early morning",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8184",
    "data-name": "Rectangle 8184",
    width: 20,
    height: 20,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_36254",
    "data-name": "Group 36254",
    transform: "translate(0.833 1.666)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "filter_drama_black_24dp",
    transform: "translate(5 2.778)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40751",
    "data-name": "Path 40751",
    d: "M0,0H13.333V13.333H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40752",
    "data-name": "Path 40752",
    d: "M10.75,7.356A4.159,4.159,0,0,0,2.978,6.244a3.332,3.332,0,0,0,.356,6.644h7.222a2.77,2.77,0,0,0,.194-5.533Zm-.194,4.422H3.333A2.222,2.222,0,1,1,5.556,9.556H6.667A3.33,3.33,0,0,0,4.222,6.344a3.05,3.05,0,0,1,5.5,1.822v.278h.833a1.667,1.667,0,1,1,0,3.333Z",
    transform: "translate(0 -1.778)",
    fill: "#898989"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_24",
    "data-name": "Subtraction 24",
    d: "M2.221,10.369h0a.567.567,0,0,1-.231-.136.536.536,0,0,1-.163-.384.551.551,0,0,1,.163-.4l.588-.588a.538.538,0,0,1,.39-.164.557.557,0,0,1,.551.629c-.051.1-.1.206-.142.3l0,0,0,0-.008.008L3.2,9.8c-.487.288-.816.479-.981.566ZM4.2,8.124h0a2.749,2.749,0,0,1-.864-2.011A2.778,2.778,0,0,1,8.422,4.571a1.5,1.5,0,0,0-.689.846c-.016.042-.033.088-.051.142a1.666,1.666,0,1,0-2.8,1.672,6.913,6.913,0,0,0-.681.892ZM1.667,6.666H.556a.555.555,0,1,1,0-1.111H1.667a.555.555,0,0,1,0,1.111Zm1.3-3.143a.554.554,0,0,1-.394-.163L1.99,2.772a.539.539,0,0,1-.163-.387.549.549,0,0,1,.163-.4.54.54,0,0,1,.39-.163.551.551,0,0,1,.393.163l.588.588a.534.534,0,0,1,.161.38.569.569,0,0,1-.161.4A.535.535,0,0,1,2.972,3.524Zm6.286,0a.571.571,0,0,1-.4-.16A.537.537,0,0,1,8.7,2.976a.554.554,0,0,1,.163-.4l.588-.588a.54.54,0,0,1,.39-.163.556.556,0,0,1,.394.163.536.536,0,0,1,.162.384.555.555,0,0,1-.162.4l-.59.588A.532.532,0,0,1,9.258,3.521Zm-3.146-1.3a.556.556,0,0,1-.556-.555V.556a.556.556,0,1,1,1.111,0V1.667A.555.555,0,0,1,6.112,2.222Z",
    transform: "translate(0.555 0.556)",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("g", {
    id: "light_mode_black_24dp",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8184-2",
    "data-name": "Rectangle 8184",
    width: 13.273,
    height: 13.273,
    fill: "none"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarlymorning);
export default __webpack_public_path__ + "static/media/earlymorning.5ca2bd03af59030f78ec92fb88d2cdad.svg";
export { ForwardRef as ReactComponent };